import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AnimationService } from 'src/app/utils/animation.service';
import { Constants } from '../../utils/constants';
import { UtmService } from '../../utils/utm.service';

@Component({
  selector: 'app-skills-requirement',
  templateUrl: './skills-requirement.component.html',
  styleUrls: ['../home.component.scss', './skills-requirement.component.scss']
})
export class SkillsRequirementComponent implements OnInit {
  studyWithUsButtonPath: String = Constants.studyWithUsButtonPath;
  formGenericUrl: string = Constants.formGenericUrl;
  formLevel1Url: string = Constants.formGenericLevel1Url;
  formLevel2Url: string = Constants.formGenericLevel2Url;
  formLevel3Url: string = Constants.formGenericLevel3Url;

  @ViewChild('cardsAnimation')
  cardsAnimation: ElementRef;

  constructor(private animation: AnimationService, private utmService: UtmService) { }

  ngOnInit(): void {
    this.formGenericUrl = this.utmService.getFormPath();
    this.formLevel1Url = this.utmService.getLevel1FormPath();
    this.formLevel2Url = this.utmService.getLevel2FormPath();
    this.formLevel3Url = this.utmService.getLevel3FormPath();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event) {
    this.animation.startDownToUpAnimation(this.cardsAnimation.nativeElement);
  }
}
